import { useRef, useState } from "react";
import { assetUrl } from "../lib/api";
import { ProductImage } from "./ProductImage";

export function MediaGallery({ images = [], video, name, discount = 0 }) {
  const media = [
    ...images.filter(Boolean).map((src) => ({ type: "image", src })),
    ...(video ? [{ type: "video", src: video }] : []),
  ];
  const list = media.length ? media : [{ type: "image", src: "" }];
  const [active, setActive] = useState(0);
  const ref = useRef(null);

  const onScroll = () => {
    const el = ref.current;
    if (!el) return;
    const idx = Math.round(el.scrollLeft / el.clientWidth);
    if (idx !== active) setActive(idx);
  };

  return (
    <div className="relative overflow-hidden rounded-2xl border border-stone-200 bg-stone-50" data-testid="product-media-gallery">
      {discount > 0 && (
        <span className="absolute left-3 top-3 z-10 rounded-full bg-stone-950 px-3 py-1 text-xs font-bold text-white">
          Save {discount}%
        </span>
      )}
      <div
        ref={ref}
        onScroll={onScroll}
        className="flex snap-x snap-mandatory overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        style={{ aspectRatio: "1 / 1" }}
      >
        {list.map((m, i) => (
          <div key={i} className="h-full w-full shrink-0 snap-center">
            {m.type === "video" ? (
              <video
                src={assetUrl(m.src)}
                controls
                playsInline
                preload="metadata"
                className="h-full w-full object-contain"
                data-testid={`gallery-video-${i}`}
              />
            ) : (
              <ProductImage
                src={m.src}
                alt={name}
                className="h-full w-full object-contain p-4"
                testId={`gallery-image-${i}`}
              />
            )}
          </div>
        ))}
      </div>
      {list.length > 1 && (
        <div className="absolute inset-x-0 bottom-3 flex justify-center gap-1.5" data-testid="gallery-dots">
          {list.map((_, i) => (
            <span
              key={i}
              className={`h-1.5 rounded-full transition-all ${i === active ? "w-5 bg-[#FF5200]" : "w-1.5 bg-stone-300"}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
